var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyTypePickUps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#body-type-pick-ups_svg__clip0_5_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15 13.7H3.1l-1.9-.6c-.1-.05-.2-.15-.2-.25V10.3c0-.1.05-.15.1-.2l.25-.2v-.4c0-.45.15-.9.4-1.25C2.2 7.65 2.9 6.9 3.8 6.9c1.05-.05 4.7-.2 5.8-.25.45 0 .85-.15 1.25-.4l5.8-3.6c.05 0 .1-.05.15-.05h7.25c.15 0 .25.1.25.25V6.4h13.4c.6 0 1.05.5 1.05 1.05v3.45c0 .9-.65 1.7-1.55 1.85l-3.1.55c-.15 0-.25-.05-.3-.2 0-.15.05-.25.2-.3l3.1-.55c.65-.1 1.15-.7 1.15-1.35V7.45c0-.3-.25-.55-.55-.55H24.05c-.15 0-.25-.1-.25-.25V3.1h-6.9l-5.7 3.55c-.45.3-.95.45-1.5.45-1.1.05-4.75.25-5.8.25-.75 0-1.35.75-1.65 1.15-.2.3-.3.6-.3.95V10c0 .1-.05.15-.1.2l-.25.2v2.25l1.7.55c.15.05.2.2.15.3-.05.1-.15.2-.3.2z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 13.7H10.75c-.15 0-.25-.1-.25-.25s.1-.25.25-.25H26.4c.15 0 .25.1.25.25s-.15.25-.25.25z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65 16.05c-1.55 0-2.85-1.25-2.85-2.85s1.25-2.85 2.85-2.85S9.5 11.6 9.5 13.2s-1.3 2.85-2.85 2.85zm0-5.15c-1.3 0-2.35 1.05-2.35 2.35s1.05 2.35 2.35 2.35S9 14.55 9 13.25 7.9 10.9 6.65 10.9zM30.5 16.05c-1.55 0-2.85-1.25-2.85-2.85s1.25-2.85 2.85-2.85c1.55 0 2.85 1.25 2.85 2.85s-1.3 2.85-2.85 2.85zm0-5.15c-1.3 0-2.35 1.05-2.35 2.35s1.05 2.35 2.35 2.35 2.35-1.05 2.35-2.35-1.1-2.35-2.35-2.35z",
    fill: "#10B1D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "body-type-pick-ups_svg__clip0_5_335"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v20H0z"
  })))));
}
export default SvgBodyTypePickUps;